import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { initSentry } from './lib/sentry'
import { initPostHog } from './lib/posthog'
import App from './App.tsx'
import './index.css'

// Initialize Sentry and PostHog before rendering the app
initSentry().then(() => {
  initPostHog();
  createRoot(document.getElementById("root")!).render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
}).catch((error) => {
  console.error("Failed to initialize Sentry:", error);
  initPostHog();
  createRoot(document.getElementById("root")!).render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
});
